import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoPopoverModule } from '../avano-popover/avano-popover.module';
import { AvanoDirectivesModule } from '../directives/avano-directives.module';
import { AvanoAppheaderIconComponent } from './avano-appheader-icon/avano-appheader-icon.component';
import { AvanoAppheaderIconAreaComponent, AvanoAppheaderMiddleAreaComponent } from './avano-appheader.common';
import { AvanoAppheaderComponent } from './avano-appheader.component';

@NgModule({
  imports: [CommonModule, AvanoDirectivesModule, AvanoPopoverModule],
  exports: [AvanoAppheaderComponent, AvanoAppheaderIconAreaComponent, AvanoAppheaderIconComponent, AvanoAppheaderMiddleAreaComponent],
  declarations: [AvanoAppheaderComponent, AvanoAppheaderIconAreaComponent, AvanoAppheaderIconComponent, AvanoAppheaderMiddleAreaComponent]
})
export class AvanoAppHeaderModule {}
